export default __webpack_public_path__ + "static/media/sylabusFilledIcon.a2ac64d1.svg";